import { useSyncExternalStore, useMemo } from "react";
import { DEFAULT_CONCIERGE_SETTINGS } from "./types.js";
function useConciergeSettings() {
  const conciergeSettings = useSyncExternalStore(
    // Subscribe function - listen for changes
    (callback) => {
      const handler = () => callback();
      window.addEventListener("brandclub:settings:update", handler);
      return () => window.removeEventListener("brandclub:settings:update", handler);
    },
    // Get snapshot - read current settings
    () => {
      var _a;
      if (typeof window === "undefined") return null;
      return (_a = window.brandclubSettings) == null ? void 0 : _a.concierge;
    },
    // Get server snapshot - return null for SSR
    () => null
  );
  return useMemo(() => ({
    ...DEFAULT_CONCIERGE_SETTINGS,
    ...conciergeSettings
  }), [conciergeSettings]);
}
function getConciergeSettings() {
  var _a;
  if (typeof window === "undefined") {
    return DEFAULT_CONCIERGE_SETTINGS;
  }
  return {
    ...DEFAULT_CONCIERGE_SETTINGS,
    ...(_a = window.brandclubSettings) == null ? void 0 : _a.concierge
  };
}
function updateConciergeSettings(newSettings) {
  var _a;
  if (typeof window === "undefined") return;
  window.brandclubSettings = {
    ...window.brandclubSettings,
    concierge: {
      ...(_a = window.brandclubSettings) == null ? void 0 : _a.concierge,
      ...newSettings
    }
  };
  window.dispatchEvent(new CustomEvent("brandclub:settings:update"));
}
export {
  getConciergeSettings,
  updateConciergeSettings,
  useConciergeSettings
};
//# sourceMappingURL=useBrandclubSettings.js.map
